import { __decorate, __metadata } from 'tslib';
import { Inject } from '@tencent/ioc';
import React, { Component } from 'react';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { ToolbarContext } from './toolbar-context.js';
import { ToolbarRenderer } from './toolbar-renderer.js';
import styles from './toolbar.less.js';
import { StateManager } from '../../../services/store/state-manager.js';
import { WorkbenchConfigurationState } from '../../../services/settings/auto-sync-settings.js';

class ShelterDropdown extends Component {
    render() {
        const { groups, totalWidth } = this.context.getShrinkedGroups(this.props.name);
        let subContainerWidth = totalWidth + 32;
        const flattenGroups = groups;
        if (totalWidth >= window.innerWidth) {
            subContainerWidth = window.innerWidth - 16;
        }
        return React.createElement(Dropdown.Keep, null,
            React.createElement("div", { className: [styles.container, styles['sub-container']].join(' '), style: {
                    width: subContainerWidth,
                    justifyContent: 'flex-start',
                } },
                React.createElement(ToolbarRenderer, { groups: flattenGroups, breakAll: true, tooltipPlacement: this.store.getValue(WorkbenchConfigurationState.ToolbarButtonTooltipPlacement) })));
    }
}
ShelterDropdown.contextType = ToolbarContext;
__decorate([
    Inject(),
    __metadata("design:type", StateManager)
], ShelterDropdown.prototype, "store", void 0);
function getShelterDropdown(name) {
    return () => React.createElement(ShelterDropdown, { name: name });
}

export { ShelterDropdown, getShelterDropdown };
//# sourceMappingURL=shelter-dropdown.js.map
